(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const openImageZoom = (imgEl) => {
		const zoomSrc = imgEl.dataset.zoomSrc || imgEl.currentSrc || imgEl.src;
		if (!zoomSrc) return;

		const overlay = document.createElement("div");
		overlay.className = "product-zoom-overlay";
		overlay.setAttribute("tabindex", "-1");
		overlay.innerHTML = `
			<button type="button" class="product-zoom-overlay__close" aria-label="Close zoom">×</button>
			<div class="product-zoom-overlay__controls">
				<button type="button" class="product-zoom-overlay__zoom-out" aria-label="Zoom out">−</button>
				<span class="product-zoom-overlay__level">100%</span>
				<button type="button" class="product-zoom-overlay__zoom-in" aria-label="Zoom in">+</button>
			</div>
			<div class="product-zoom-overlay__inner">
				<img src="${zoomSrc}" alt="" class="product-zoom-overlay__img" draggable="false" />
			</div>
		`;

		const inner = overlay.querySelector(".product-zoom-overlay__inner");
		const img = overlay.querySelector(".product-zoom-overlay__img");
		const levelDisplay = overlay.querySelector(".product-zoom-overlay__level");
		const closeBtn = overlay.querySelector(".product-zoom-overlay__close");
		const zoomInBtn = overlay.querySelector(".product-zoom-overlay__zoom-in");
		const zoomOutBtn = overlay.querySelector(".product-zoom-overlay__zoom-out");

		let scale = 1;
		let posX = 0;
		let posY = 0;
		let isDragging = false;
		let startX, startY, startPosX, startPosY;

		const minScale = 0.5;
		const maxScale = 4;
		const zoomStep = 0.25;

		const updateTransform = () => {
			img.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
			levelDisplay.textContent = Math.round(scale * 100) + "%";
		};

		const setScale = (newScale) => {
			scale = Math.min(maxScale, Math.max(minScale, newScale));
			updateTransform();
		};

		const handleWheel = (e) => {
			e.preventDefault();
			const delta = e.deltaY > 0 ? -zoomStep : zoomStep;
			setScale(scale + delta);
		};

		const handlePointerDown = (e) => {
			if (e.target.closest("button")) return;
			isDragging = true;
			startX = e.clientX;
			startY = e.clientY;
			startPosX = posX;
			startPosY = posY;
			inner.style.cursor = "grabbing";
		};

		const handlePointerMove = (e) => {
			if (!isDragging) return;
			posX = startPosX + (e.clientX - startX);
			posY = startPosY + (e.clientY - startY);
			updateTransform();
		};

		const handlePointerUp = () => {
			isDragging = false;
			inner.style.cursor = scale > 1 ? "grab" : "default";
		};

		let lastPinchDist = null;
		const handleTouchMove = (e) => {
			if (e.touches.length === 2) {
				e.preventDefault();
				const dist = Math.hypot(
					e.touches[1].clientX - e.touches[0].clientX,
					e.touches[1].clientY - e.touches[0].clientY
				);
				if (lastPinchDist !== null) {
					setScale(scale + (dist - lastPinchDist) * 0.008);
				}
				lastPinchDist = dist;
			} else {
				lastPinchDist = null;
			}
		};
		const handleTouchEnd = () => {
			lastPinchDist = null;
		};

		const close = () => {
			overlay.remove();
			document.body.style.overflow = "";
			inner.removeEventListener("wheel", handleWheel, { passive: false });
			inner.removeEventListener("touchmove", handleTouchMove, { passive: false });
			inner.removeEventListener("touchend", handleTouchEnd);
			document.removeEventListener("pointermove", handlePointerMove);
			document.removeEventListener("pointerup", handlePointerUp);
		};

		closeBtn.addEventListener("click", close);
		overlay.addEventListener("click", (e) => {
			if (e.target === overlay) close();
		});
		overlay.addEventListener("keydown", (e) => {
			if (e.key === "Escape") close();
		});

		zoomInBtn.addEventListener("click", () => setScale(scale + zoomStep));
		zoomOutBtn.addEventListener("click", () => setScale(scale - zoomStep));

		inner.addEventListener("wheel", handleWheel, { passive: false });
		inner.addEventListener("touchmove", handleTouchMove, { passive: false });
		inner.addEventListener("touchend", handleTouchEnd);
		inner.addEventListener("pointerdown", handlePointerDown);
		document.addEventListener("pointermove", handlePointerMove);
		document.addEventListener("pointerup", handlePointerUp);

		img.addEventListener("load", () => {
			inner.style.cursor = scale > 1 ? "grab" : "default";
		});

		document.body.appendChild(overlay);
		document.body.style.overflow = "hidden";
		overlay.focus();
	};
	document.addEventListener("click", (e) => {
    const img = e.target.closest(".js-image-zoom");

    if (!img) return;

    openImageZoom(img);
  });
	const revealPopup = () => {
		const stickyBar = document.querySelector(".product__popup"); // Sticky bar
		//const secondSection = document.querySelector(".product-section + section"); // Second section
		const secondSection =
			document.querySelector(".product-section + section") ||
			document.querySelector(".product-section + .shopify-section");
		const footer = document.querySelector("footer"); // Footer

		// Only proceed if sticky bar exists (other elements are optional)
		if (!stickyBar) {
			return;
		}

		// Check if other required elements exist for scroll-based functionality
		if (!secondSection || !footer) {
			return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset =
				window.scrollY > secondSectionMid && scrollPosition < footerTop;

			stickyBar.classList[activeOffset ? "add" : "remove"]("active");
		};

		// Initial check in case the user starts in the middle of the page
		handleScroll();
	};

	let stickyFrame = 0;
    document.addEventListener("scroll", () => {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; revealPopup(); });
    }, { passive: true });

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		revealPopup();
	});

	initProductAccordion();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		const sectionId = document
			.querySelector("[id^='MainProduct-']")
			?.id?.replace("MainProduct-", "");
        // Reuse server-rendered product data rather than fetching the whole page again.
        const source = document.getElementById(`ProductInfo-${sectionId}`);
        if (!source) return;
        Promise.resolve().then(() => {
                const detached = new DOMParser().parseFromString(source.outerHTML, 'text/html');
                this.productElement = detached.querySelector('div[id^="ProductInfo-"]');

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				// Convert variant-radios pill fieldsets to dropdowns.
				// Queried from `this` (not document) to avoid cross-contamination with
				// other .product__popup elements on the page.
				// The :not(.product-form__controls--dropdown) guard makes the conversion
				// idempotent — already-converted fieldsets are never processed twice.
				this.querySelectorAll("variant-radios").forEach((radiosBlock) => {
					radiosBlock
						.querySelectorAll(
							".product-form__controls" +
							":not(.product-form__controls--dropdown)"
						)
						.forEach((fieldset) => {
							fieldset.classList.add(
								"product-form__input--dropdown",
								"product-form__controls--dropdown"
							);

							const legend = fieldset.querySelector("legend");
							const wrapper = legend?.querySelector(".product-form__group-name__wrapper");
							const groupName =
								Array.from((wrapper || legend)?.childNodes ?? [])
									.filter(n => n.nodeType === Node.TEXT_NODE)
									.map(n => n.textContent.trim())
									.filter(Boolean)
									.join("") || legend?.textContent.trim() || "";
							const cleanGroupName = groupName.replace(/:+$/g, "").trim();

							const dropdownSelect = document.createElement("div");
							dropdownSelect.className = "select dropdown-select";
							dropdownSelect.innerHTML = `
								<div class="select-wrapper">
									<div class="select-label medium-font" tabindex="0" role="button" aria-haspopup="listbox" aria-expanded="false">
										${cleanGroupName}: <span></span>
									</div>
									<ul class="product-form__controls-group" role="listbox"></ul>
									<div class="select-wrapper__scroll-shadow shadow-bottom"></div>
								</div>
								<svg width="22" height="22" viewBox="0 0 22 22" fill="none" class="icon icon-arrow-small" xmlns="http://www.w3.org/2000/svg"><path d="M11 14.1166L5.5 8.61659L6.78333 7.33325L11 11.5499L15.2167 7.33325L16.5 8.61659L11 14.1166Z" fill="currentColor"/></svg>
							`;

							const optionsList = dropdownSelect.querySelector("ul");
							const selectLabel = dropdownSelect.querySelector(
								".select-wrapper > .select-label"
							);
							const selectedSpan = selectLabel?.querySelector("span");

							fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
								const label = fieldset.querySelector(`label[for="${input.id}"]`);
								if (!label) return;

								label.querySelectorAll(".variant-popular-label").forEach(s => s.remove());

								// Color swatch and variant-image swatch labels have complex markup
								// (circles, background images, hidden spans). Replace their content
								// with a plain text span so the dropdown trigger and click handler
								// can read .pills-variant-labels-text uniformly, regardless of the
								// global variant style setting (Pills, Swatches, etc.).
								if (label.classList.contains("color-swatch") || label.classList.contains("variant-swatch")) {
									const isNotifyMe = label.classList.contains("notify_me");
									const valueSpan = document.createElement("span");
									valueSpan.className = "pills-variant-labels-text small-font";
									valueSpan.textContent = input.value || label.getAttribute("title") || "";
									label.innerHTML = "";
									label.appendChild(valueSpan);
									label.className = isNotifyMe ? "pills-variant-labels notify_me" : "";
								} else {
									label.querySelectorAll(".visually-hidden").forEach(s => s.remove());
									label.childNodes.forEach((node) => {
										if (
											node.nodeType === 3 &&
											node.textContent.includes("Variant sold out or unavailable")
										) {
											node.remove();
										}
									});
								}

								const li = document.createElement("li");
								li.setAttribute("role", "option");
								li.appendChild(input);
								li.appendChild(label);
								optionsList.appendChild(li);
							});

							if (legend) legend.remove();
							fieldset
								.querySelectorAll(".product-form__controls-group, .product-frame-reassurance, .product-selected-size, .variant-popular-label, .size-guide-btn, modal-opener, modal-dialog")
								.forEach(el => el.remove());

							fieldset.appendChild(dropdownSelect);

							if (selectedSpan) {
								const checkedRadio = optionsList.querySelector('input[type="radio"]:checked');
								if (checkedRadio) {
									const label = optionsList.querySelector(`label[for="${checkedRadio.id}"]`);
									const selectedValue = label
										? label.querySelector(".pills-variant-labels-text")?.textContent.trim() ||
										  label.textContent.trim()
										: checkedRadio.value;
									selectedSpan.textContent = selectedValue;
									selectedSpan.setAttribute("title", selectedValue);
								} else {
									selectedSpan.textContent = "Select";
								}
							}
						});
				});

				this.showMoreFields();
				window.initVariantDropdowns?.();
				this.syncWithMainVariantPicker();
			});
	}

	async syncWithMainVariantPicker() {
		const floatedPicker = this.querySelector("variant-selects, variant-radios");
		const mainSectionId = floatedPicker?.dataset.originalSection;

		if (!floatedPicker || !mainSectionId) return;
        await customElements.whenDefined(floatedPicker.localName);
        if (!floatedPicker.isConnected) return;
        customElements.upgrade(floatedPicker);

		const mainPicker = document.getElementById(
			`variant-picker-${mainSectionId}`
		);

		if (!mainPicker?.getSelectedValues) return;

		floatedPicker.setCheckedInputsBySelectedValues(
			mainPicker.getSelectedValues()
		);

		if (typeof floatedPicker.updateFloatedDropdownLabels === "function") {
			floatedPicker.updateFloatedDropdownLabels(floatedPicker);
		}

		const mainVariantId = document
			.getElementById(`product-form-${mainSectionId}`)
			?.querySelector('input[name="id"]')?.value;
		const floatedForm = document.getElementById(
			`product-form-floated-${mainSectionId}`
		);
		const floatedVariantInput = floatedForm?.querySelector('input[name="id"]');

		if (mainVariantId && floatedVariantInput) {
			floatedVariantInput.value = mainVariantId;
		}

		const mainPrice = document.getElementById(`price-${mainSectionId}`);
		const floatedPrice = document.getElementById(
			`price-floated-${mainSectionId}`
		);

		if (mainPrice && floatedPrice) {
			floatedPrice.innerHTML = mainPrice.innerHTML;
		}
	}

    setInnerHTML(element, html) {
        const template = document.createElement('template');
        template.innerHTML = html;
        template.content.querySelectorAll('script').forEach((script) => {
            if (!script.type || /(?:java|ecma)script/.test(script.type)) script.remove();
        });
        element.replaceChildren(template.content);
    }

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		this.productElement
			.querySelectorAll(".product__text")
			.forEach((el) => el.remove());

		this.productElement
			.querySelectorAll(".product-about")
			.forEach((el) => el.remove());

		this.productElement
			.querySelectorAll(".custom-liquid")
			.forEach((el) => el.remove());

		this.productElement
			.querySelectorAll(
				".product-cta-microcopy, .product-cta-review, .product-info-grid, .product-impact, .product-trust-chips, .product-frame-reassurance, .product-selected-size, .variant-popular-label"
			)
			.forEach((el) => el.remove());

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

		const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

		const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".main-product-description-block"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(
			".inventory product__inventory"
		);
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations--single"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();

		this.productElement
			.querySelectorAll(".linked-products")
			.forEach((el) => el.remove());
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

